window.addEventListener("load", function () {
    const tabPanels = document.querySelectorAll(".vehicle-tab-panel");

    for (const tabPanel of tabPanels) {
        const tabButtons = tabPanel.querySelectorAll('button[data-tab]');
        const tabContentItems = tabPanel.querySelectorAll('[data-tab-content] [data-tab]');

        tabButtons.forEach(button => {
            button.addEventListener('click', function () {
                const clickedTab = button.dataset.tab;

                // Deactivate all buttons and content
                tabButtons.forEach(b => b.dataset.active = 'false');
                tabContentItems.forEach(item => item.dataset.active = 'false');

                // Activate clicked button and corresponding content
                button.dataset.active = 'true';
                const activeContent = tabPanel.querySelector(`[data-tab-content] [data-tab="${clickedTab}"]`);
                if (activeContent) {
                    activeContent.dataset.active = 'true';
                }
            });
        });
    }
});